enum SectionAttributeGroups {
  Tabs = "Tabs",
  Components = "Components",
  Tables = "Tables",
  Layouts = "Layouts",
}
export default SectionAttributeGroups;
